define("shared/models/ig-preview-post", ["exports", "@ember/debug", "@ember/object", "@ember/utils", "moment", "rsvp"], function (_exports, _debug, _object, _utils, _moment, _rsvp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _class;

  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/object",0,"@ember/utils",0,"ember-classic-decorator",0,"moment",0,"rsvp"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  let IgPreviewPost = (_dec = (0, _object.computed)('isIgPost', 'isNew', 'mediaItem.id', 'isCurrentlyScheduled', 'gram.id'), _dec2 = (0, _object.computed)('isIgPost', 'igPost.displayTime', 'isNew', 'newScheduledTime', 'isCurrentlyScheduled', 'gram.scheduledTime'), _dec3 = (0, _object.computed)('isIgPost', 'isNew', 'newScheduledTime', 'isCurrentlyScheduled', 'gram.scheduledTime'), _dec4 = (0, _object.computed)('isIgPost', 'igPost', 'igPost.secureThumbUrl', 'isNew', 'mediaItem', 'mediaItem.medThumbnailOrProcessingUrl', 'isCurrentlyScheduled', 'gram', 'gram.medThumbnailOrMediaMedThumbnail'), _dec5 = (0, _object.computed)('isCarousel', 'isVideo'), _dec6 = (0, _object.computed)('igPost.isIGTV'), _dec7 = (0, _object.computed)('scheduledTime'), _dec8 = (0, _object.computed)('scheduledTime'), _dec9 = (0, _object.computed)('imageUrl'), _dec10 = (0, _object.computed)('mediaItem.isVideo', 'igPost.isVideo', 'gram.isVideo'), _dec11 = (0, _object.computed)('igPost.isCarouselPost', 'gram.isCarouselPost'), _dec12 = (0, _object.computed)('igPost.isReels', 'gram.isInstagramReel'), _dec13 = (0, _object.computed)('gram.isDraft'), _dec14 = (0, _object.computed)('originalScheduledTime', 'scheduledTime'), _dec15 = (0, _object.computed)('originalQueueOrder', 'queueOrder'), _dec16 = (0, _object.computed)('isIgPost', 'hasUpdatedScheduledTime', 'hasUpdatedQueueOrder', 'isNew', 'isRemoved'), _dec17 = (0, _object.computed)('isNew', 'isCurrentlyScheduled'), _dec18 = (0, _object.computed)('isNew', 'isCurrentlyScheduled', 'gram.isSaving'), _dec19 = (0, _object.computed)('canMove', 'canDelete'), _dec20 = (0, _object.computed)('igPost'), _dec21 = (0, _object.computed)('gram'), _dec22 = (0, _object.computed)('mediaItem'), _dec23 = (0, _object.computed)('isIgPost', 'isNew', 'isCurrentlyScheduled'), _dec24 = (0, _object.computed)('isNew', 'isRemoved', 'hasUpdatedScheduledTime', 'hasUpdatedQueueOrder', 'hasBeenEdited'), (_class = class IgPreviewPost extends _object.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "id", void 0);

      _defineProperty(this, "socialProfile", void 0);

      _defineProperty(this, "gram", void 0);

      _defineProperty(this, "mediaItem", void 0);

      _defineProperty(this, "igPost", void 0);

      _defineProperty(this, "scheduledTime", void 0);

      _defineProperty(this, "newScheduledTime", void 0);

      _defineProperty(this, "isRemoved", false);

      _defineProperty(this, "originalQueueOrder", void 0);

      _defineProperty(this, "queueOrder", void 0);
    }

    get autoSchedulingId() {
      if (this.isIgPost) {
        return;
      } else if (this.isNew) {
        return 'media_item::' + this.get('mediaItem')?.id;
      } else if (this.isCurrentlyScheduled) {
        return 'gram::' + this.get('gram')?.id;
      }

      return;
    }

    get originalScheduledTime() {
      if (this.isIgPost) {
        return this.igPost?.displayTime;
      } else if (this.isNew) {
        return this.newScheduledTime;
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram')?.scheduledTime ?? undefined;
      }

      return;
    }

    get description() {
      if (this.isIgPost) {
        return '';
      } else if (this.isNew) {
        return this.get('mediaItem')?.defaultCaption;
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram')?.caption;
      }

      return;
    }

    get imageUrl() {
      if (this.isIgPost) {
        return this.igPost?.secureThumbUrl ?? '';
      } else if (this.isNew) {
        return this.get('mediaItem')?.medThumbnailOrProcessingUrl ?? '';
      } else if (this.isCurrentlyScheduled) {
        return this.get('gram')?.medThumbnailOrMediaMedThumbnail ?? '';
      }

      return '';
    }

    get shouldShowVideoIcon() {
      return !this.isCarouselPost && this.isVideo;
    }

    get mediaIcon() {
      return this.igPost?.isIGTV ? 'igtv' : 'video';
    }

    get scheduledMoment() {
      if ((0, _utils.isNone)(this.scheduledTime)) {
        return;
      }

      return (0, _moment.default)(this.scheduledTime * 1000);
    }

    get hasScheduledTime() {
      return !(0, _utils.isNone)(this.scheduledTime);
    }

    get secureImageUrl() {
      if (!(0, _utils.isEmpty)(this.imageUrl)) {
        return this.imageUrl.replace('http://', 'https://');
      }

      return '';
    }

    get isVideo() {
      return !this.isReelsPost && Boolean(this.get('mediaItem')?.isVideo) || Boolean(this.igPost?.isVideo) || Boolean(this.get('gram')?.isVideo);
    }

    get isCarouselPost() {
      return Boolean(this.igPost?.isCarouselPost) || Boolean(this.get('gram')?.isCarouselPost);
    }

    get isReelsPost() {
      return Boolean(this.igPost?.isReels) || Boolean(this.get('gram')?.isInstagramReel);
    }

    get isDraftPost() {
      return Boolean(this.get('gram')?.isDraft);
    }

    get hasUpdatedScheduledTime() {
      if (this.isIgPost) {
        return false;
      }

      return this.originalScheduledTime !== this.scheduledTime;
    }

    get hasUpdatedQueueOrder() {
      if (this.isIgPost) {
        return false;
      }

      return this.originalQueueOrder !== this.queueOrder;
    }

    get hasBeenEdited() {
      if (this.isIgPost) {
        return false;
      }

      return this.hasUpdatedScheduledTime || this.hasUpdatedQueueOrder || this.isRemoved || this.isNew;
    }

    get canMove() {
      return this.isNew || this.isCurrentlyScheduled;
    }

    get canDelete() {
      return this.isNew || this.isCurrentlyScheduled && !this.get('gram')?.isSaving;
    }

    get canEdit() {
      return this.canMove || this.canDelete;
    }

    get isIgPost() {
      return !(0, _utils.isNone)(this.igPost);
    }

    get isCurrentlyScheduled() {
      return !(0, _utils.isNone)(this.get('gram'));
    }

    get isNew() {
      return !(0, _utils.isNone)(this.get('mediaItem'));
    }

    get cssHandle() {
      if (this.isIgPost) {
        return 'e--post__ig';
      } else if (this.isNew) {
        return 'e--post__new';
      } else if (this.isCurrentlyScheduled) {
        return 'e--post__scheduled';
      }

      return '';
    }

    get editedCssClass() {
      if (this.isNew) {
        return 'has--changes';
      } else if (this.isRemoved) {
        return 'has--changes';
      } else if (this.hasUpdatedScheduledTime) {
        return 'has--changes';
      } else if (this.hasUpdatedQueueOrder) {
        return 'has--changes';
      } else if (this.hasBeenEdited) {
        return 'has--changes';
      }

      return '';
    }

    remove() {
      if (this.isCurrentlyScheduled) {
        this.set('isRemoved', true);
      }
    }

    persist() {
      return new _rsvp.Promise((resolve, reject) => {
        if (this.get('isCurrentlyScheduled')) {
          const gram = this.get('gram');

          if (!gram) {
            reject('Gram is undefined');
          } else {
            if (this.get('isRemoved')) {
              gram.destroyRecord().then(() => {
                resolve();
              }, reason => {
                reject(reason);
              });
            } else {
              gram.set('scheduledTime', this.scheduledTime);
              gram.save().then(() => {
                resolve();
              }, reason => {
                reject(reason);
              });
            }
          }
        } else if (this.isNew) {
          (0, _debug.debug)('== persisting IgPreviewPost: ' + this.id);
          resolve();
        }
      });
    }

    reset() {
      if (this.isCurrentlyScheduled) {
        this.set('scheduledTime', this.originalScheduledTime);
        this.set('isRemoved', false);
        this.set('queueOrder', this.originalQueueOrder);
      } else if (this.isNew) {
        this.set('scheduledTime', this.newScheduledTime);
        this.set('queueOrder', this.originalQueueOrder);
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "autoSchedulingId", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "autoSchedulingId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "originalScheduledTime", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "originalScheduledTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowVideoIcon", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowVideoIcon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mediaIcon", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "mediaIcon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scheduledMoment", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "scheduledMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasScheduledTime", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "hasScheduledTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureImageUrl", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "secureImageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isVideo", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "isVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCarouselPost", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "isCarouselPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReelsPost", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "isReelsPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDraftPost", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "isDraftPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUpdatedScheduledTime", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "hasUpdatedScheduledTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUpdatedQueueOrder", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "hasUpdatedQueueOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasBeenEdited", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "hasBeenEdited"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canMove", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "canMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDelete", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "canDelete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEdit", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "canEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIgPost", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "isIgPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurrentlyScheduled", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "isCurrentlyScheduled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNew", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "isNew"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cssHandle", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "cssHandle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editedCssClass", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "editedCssClass"), _class.prototype)), _class));
  _exports.default = IgPreviewPost;
});